import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedStyleID: '',
  isAddingText: false,
};

const toolActionSlice = createSlice({
  name: 'tool',
  initialState,
  reducers: {
    setSelectedStyleID: (state, action) => {
      state.selectedStyleID = action.payload; // expects string
    },
    setAddingTextStatus: (state, action) => {
      state.isAddingText = action.payload; // expects boolean
    },
  },
});

export const { setSelectedStyleID, setAddingTextStatus } = toolActionSlice.actions;

export default toolActionSlice.reducer;
